module.exports = __webpack_public_path__ + "media/banners/arrow-btn-baner-ca110eb0.png";